import { AsyncPipe } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'lib-boolean-icon',
  template: `
    @if ({ row: columnData | async }; as $) {
      <i [class]="($.row?.is_cumulative ? 'pi pi-check-circle text-green-500 text-xl' : 'pi pi-times-circle text-red-500 text-xl')"></i>
    }
    `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe]
})
export class BooleanIconComponent {
  columnData: Observable<any> = new BehaviorSubject<any>(null);
  additionData: Observable<any> = new BehaviorSubject<any>(null);
}


